export default __webpack_public_path__ + "static/media/activity.7efcf6dd.svg";